// External listing source these properties are mirrored/sourced from.
// Surfaced as a "view on original site" link in table rows, cards, and
// the detail page.
export const EXTERNAL_LISTING_URL = "https://emlak-bazasi.com";
